var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexDescription/IndexDescription.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexDescription/IndexDescription.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n<div class=\"IndexDescription\">\n    <div class=\"IndexDescription-desc\">\n        <div class=\"IndexDescription-deals\">\n            ";
var t_4;
t_4 = runtime.contextOrFrameLookup(context, frame, "dealsCount") % 10;
frame.set("dealsCountMod", t_4, true);
if(frame.topLevel) {
context.setVariable("dealsCountMod", t_4);
}
if(frame.topLevel) {
context.addExport("dealsCountMod", t_4);
}
output += "\n            <div class=\"IndexDescription-dealsCount\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "dealsCount"), env.opts.autoescape);
output += "</div>\n            <div class=\"IndexDescription-dealsText\">";
if(runtime.contextOrFrameLookup(context, frame, "dealsCountMod") == 1) {
output += "\n                сделку";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "dealsCountMod") >= 2 && runtime.contextOrFrameLookup(context, frame, "dealsCountMod") <= 4) {
output += "сделки";
;
}
else {
output += "сделок";
;
}
;
}
output += " с\n                недвижимостью провели эксперты ГБН, поэтому мы знаем,\n                где вас подстерегает опасность и где можно сэкономить\n            </div>\n        </div>\n        <div class=\"IndexDescription-text\">\n            <p>Работаем со вторичным жильём, новостройками, загородной и коммерческой недвижимостью в Москве и&nbsp;ближайшем\n                Подмосковье — 50 км от МКАД.</p>\n            <p>Помогаем в простых и сложных случаях: материнский капитал, опека, военная ипотека, недвижимость в залоге\n                или под арестом, когда содольщик не даёт согласия, когда вы в другом городе или у вас другая\n                трудность.</p>\n            <p class=\"IndexDescription-guarantees\">Каждая сделка проходит несколько уровней проверок до заключения\n                договора. Проверяют директор и юрист.\n                Поэтому мы гарантируем безопасность, когда одобряем выход клиента на сделку с контрагентом.\n                ";
output += runtime.suppressValue((lineno = 22, colno = 40, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["100-percentages",runtime.makeKeywordArgs({"caller": (function (){var macro_t_5 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_6 = "";;
frame = frame.pop();
return new runtime.SafeString(t_6);
});
return macro_t_5;})()})])), env.opts.autoescape);
output += "</p>\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexDescription/IndexDescription.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexDescription/IndexDescription.jinja
// module id = 26
// module chunks = 0